import { formatUnits } from 'viem';

const precisions = {
  usdc: 2,
  usd: 2,
};

export const formatTokenAmount = (amount: bigint, decimals: number, token: keyof typeof precisions) => {
  const formatted = Number(formatUnits(amount, decimals)).toFixed(precisions[token]);
  return formatted.replace(/\.?0+$/, ''); // Remove trailing zeros and decimal point if all zeros
};
